/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubjectFieldHistoryRequest } from '../../models/subject-field-history-request';
import { SubjectFieldHistoryResponse } from '../../models/subject-field-history-response';

export interface PostApiSubjectV1IdHistory$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: SubjectFieldHistoryRequest
}

export function postApiSubjectV1IdHistory$Plain(http: HttpClient, rootUrl: string, params: PostApiSubjectV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectFieldHistoryResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiSubjectV1IdHistory$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubjectFieldHistoryResponse>;
    })
  );
}

postApiSubjectV1IdHistory$Plain.PATH = '/private/v1/subjects/{id}/history';
